import { BlogArticleLocale } from "./BlogArticleContent";

export enum BlogArticleKey {
  CALL_ANALYSIS_TOOLS = "call-analysis-tools",
  OFFER_BUILD = "offer-build",
  CLIENT_AVATAR_BUILD = "client-avatar-build",
  SITUATION_TARGETING = "situation-targeting",
  LINKEDIN_MESSAGE = "linkedin-message",
  MODJO_ALTERNATIVES = "modjo-alternatives",
  LEEXI_PRICING = "leexi-pricing",
  FREE_CALL_ANALYSIS = "free-call-analysis",
  NETWORK_QUALIFICATION = "network-qualification",
  CALL_RECORDING_GDPR = "call-recording-gdpr",
  SMALL_TEAM_CALL_ANALYSIS = "small-team-call-analysis",
  DISCOVERY_CALL = "discovery-call",
  LINKEDIN_LIMITS = "linkedin-limits",
  FOLLOW_UP_SEQUENCE = "follow-up-sequence",
  OFFER_NOT_SELLING = "offer-not-selling",
  AVATAR_VALIDATION = "avatar-validation",
  OFFER_PRICING = "offer-pricing",
  AVATAR_WITHOUT_CLIENTS = "avatar-without-clients",
  REPLY_TO_MEETING = "reply-to-meeting",
  SALES_NAVIGATOR = "sales-navigator",
  BUYING_SIGNALS = "buying-signals",
}

export type BlogArticle = {
  key: BlogArticleKey;
  slug: Record<string, string>;
  categoryId: string;
  date: string;
  updated?: string;
  readTime: number;
  locales: Record<string, BlogArticleLocale>;
};
